var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Masonry',{staticClass:"custom-masonry",attrs:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }